var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.61 10.742a4.177 4.177 0 100-8.354 4.177 4.177 0 000 8.354zM10.61 11.622a6.603 6.603 0 00-6.595 6.595.44.44 0 00.44.44h12.311a.44.44 0 00.44-.44 6.603 6.603 0 00-6.596-6.595z",
    fill: "#fff"
  })));
}
export default SvgSvgUser;